import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { EventsService } from '@lunaeme/circe-core';

@Directive({
  selector: '[ccClickOutside]'
})
export class ClickOutsideDirective {
  @Input() apply: boolean = true;
  @Input() exceptions: Array<string> = [];
  @Output() clickOutside: EventEmitter<undefined> = new EventEmitter();

  private readonly _host: HTMLElement;

  constructor(
    private _ev: EventsService,
    private _el: ElementRef<HTMLElement>
  ) {
    this._host = this._el.nativeElement;
  }

  @HostListener('document:click', ['$event']) onMouseEnter(event: Event) {
    if (this.apply) {
      this._ev.preventNoNeededEvent(event);
      const _eventTarget: HTMLElement = event.target as HTMLElement;
      if (!this._host.contains(_eventTarget) && (!this.exceptions.includes(_eventTarget.id))) {
        this.clickOutside.emit();
      }
    }
  }
}
